var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoAllDevices = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6759_41547)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.55621 5.00016H13.5562V3.8335H3.55621C2.9451 3.8335 2.4451 4.3585 2.4451 5.00016V11.4168H1.33398V13.1668H9.11176V11.4168H3.55621V5.00016ZM14.1118 6.16683H10.7784C10.4729 6.16683 10.2229 6.42933 10.2229 6.75016V12.5835C10.2229 12.9043 10.4729 13.1668 10.7784 13.1668H14.1118C14.4173 13.1668 14.6673 12.9043 14.6673 12.5835V6.75016C14.6673 6.42933 14.4173 6.16683 14.1118 6.16683ZM13.5562 11.4168H11.334V7.3335H13.5562V11.4168Z",
    fill: "#8D939C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6759_41547"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#fff",
    transform: "translate(0 .5)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoAllDevices);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_all_devices.b267949807eda8dc9a090a7ad6342b1b.svg";